import React from 'react';
import { EdgeProps } from 'reactflow';

const SubAgentEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) => {
  // Create elbow connector: down from orchestrator bottom, then right to sub-agent
  // Making a clear L shape: down first, then elbow right
  
  // L-shaped path: straight down, then elbow right to target
  const edgePath = `
    M ${sourceX},${sourceY}
    L ${sourceX},${targetY}
    L ${targetX},${targetY}
  `;

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
    </>
  );
};

export default SubAgentEdge;

